import { NotificationDetailsField } from './NotificationDetailsField';
import { ServerSelectField } from './ServerSelectField';
import { SwitchField } from './SwitchField';
import { DateTimeField } from './DateTimeField';
import { NotificationTimingField } from './NotificationTimingField';
import { TotalItemsField } from './TotalItemsField';
import { AudienceSelectField } from './AudienceSelectField';
import { CheckboxesField } from './CheckboxesField';
import { TextCampField } from './TextCampField';
import { ImageUploadField } from './ImageUploadField';
import { DeepLinksField } from './DeepLinksField';

const CampaignsFields = {
    text: TextCampField,
    checkboxes: CheckboxesField,
    notificationDetails: NotificationDetailsField,
    serverSelect: ServerSelectField,
    switch: SwitchField,
    dateTime: DateTimeField,
    audienceSelect: AudienceSelectField,
    totalItems: TotalItemsField,
    notificationTiming: NotificationTimingField,
    imageUpload: ImageUploadField,
    deepLinks: DeepLinksField
};
export default CampaignsFields;
